import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Notifications from "vue-notification";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueApollo from "vue-apollo";
import eLib from "@entersight/e-lib-components";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import { apolloClient } from "@/apollo.config";

Vue.config.productionTip = false;
Vue.use(eLib);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueApollo);
Vue.use(Vuex);
Vue.use(Notifications);
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

new Vue({
  router,
  store,
  apolloProvider,
  render: (h) => h(App),
}).$mount("#app");
